import React, { useEffect, useState } from "react";
import axios from "axios";


import "bootstrap/dist/css/bootstrap.min.css";


const Enquiry = () => {
  const [contacts, setContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
   const [previewMessage, setPreviewMessage] = useState(null);

  useEffect(() => {
    fetchContact();
  }, []);

     const fetchContact = async () => {
      try {
        const res = await axios.get(
          "https://api.bigfresh.in/fetch-contact"
        );
        setContacts(res.data.contactUser || []);
      } catch (error) {
        console.error("Failed to fetch contacts", error);
      } finally {
        setLoading(false);
      }
    };

  // Filter contacts (safe for number/string)
  const filteredContacts = contacts.filter((ele) => {
    const name = ele.name?.toLowerCase() || "";
    const phone = ele.phone?.toString() || "";

    return (
      name.includes(searchTerm.toLowerCase()) ||
      phone.includes(searchTerm)
    );
  });

  return (
    <div className="dashboard-container">
  


      <div className="main-dashboard">
        <div className="container my-4">
           <h3 className="text-center  mb-4 text-success fw-bold">User Contact</h3>
          <div className="d-flex justify-content-between align-items-center mb-3">
            

            <input
              type="text"
              placeholder="Search by name or phone"
              className="form-control w-50"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* Loading */}
          {loading && (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" />
            </div>
          )}

          {/* Table */}
          {!loading && (
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-dark text-center">
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Message</th>
                  </tr>
                </thead>

                <tbody className="text-center">
                  {filteredContacts.length > 0 ? (
                    filteredContacts.map((ele) => (
                      <tr key={ele.id}>
                        <td>{ele.name}</td>
                        <td>{ele.email}</td>
                        <td>{ele.phone}</td>
                        {/* <td>{ele.message}</td> */}
                        <td >
  {/* Preview button */}
  <button
    className="btn btn-sm btn-outline-primary"
    onClick={() => setPreviewMessage(ele.message)}
  >
    Preview
  </button>

 
</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-muted fw-bold">
                        No contacts found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {previewMessage && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Message Preview</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setPreviewMessage(null)}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <p>{previewMessage}</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setPreviewMessage(null)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default Enquiry;
